import { Observable } from 'rxjs';

import { ApiPaperPlagiarismReportListItem } from 'content-manager/src/app/core/open-api/content-manager-api-client';
import { PlagiarismCheckResultRendererComponent } from 'content-manager/src/app/projects/project/plagiarism-reports/renderers/check-result/plagiarism-check-result-renderer.component';
import { RendererMetadata } from 'sc-common';

export class PlagiarismReportsRenderers {

    public static checkResult(getViewerUrl: (item: ApiPaperPlagiarismReportListItem) => Observable<string>): RendererMetadata<PlagiarismCheckResultRendererComponent> {
        return {
            componentType: PlagiarismCheckResultRendererComponent,
            initializer: inst => inst.getViewerUrl = getViewerUrl
        };
    }
}
